<script setup lang="ts">
import Sidebar from './Sidebar.vue'
import AppHeader from './AppHeader.vue'
</script>

<template>
  <div class="flex h-screen overflow-hidden bg-gray-50">
    <Sidebar />
    <div class="flex flex-1 flex-col overflow-hidden md:ml-20">
      <AppHeader />
      <!-- `relative` + `overflow-x-hidden` van juntos y cada uno hace la mitad
           del trabajo (OPSENG-3072):

           - Con `overflow-y-auto`, CSS convierte el `overflow-x: visible` en
             `auto`, asi que `main` scrolleaba en horizontal y arrastraba de
             costado el contenido que vive bajo la banda sticky. `overflow-x-hidden`
             le devuelve la propiedad del scroll horizontal al contenedor de cada
             tabla.
           - Un descendiente `absolute` solo lo recorta un ancestro que este en su
             cadena de bloque contenedor. Con `main` en `static`, esos elementos
             (p.ej. los `sr-only` de las tablas anchas) se colgaban del bloque
             contenedor inicial, esquivaban los tres `overflow` del layout y
             estiraban el ancho scrolleable del *viewport*: la pagina entera se
             corria de lado y la banda quedaba cortada. `relative` los ancla a
             `main`, donde el recorte si aplica. -->
      <main class="relative flex-1 overflow-y-auto overflow-x-hidden p-4">
        <div class="mx-auto max-w-screen-2xl">
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>
